import api from "./client";

export function getAdminInmates() {
  return api.get("/admin/inmates");
}

export function getAdminInmate(id) {
  return api.get(`/admin/inmates/${id}`);
}

export function createInmate(data) {
  return api.post("/admin/inmates", data);
}

export function updateInmate(id, data) {
  return api.put(`/admin/inmates/${id}`, data);
}

export function generateTempPin(id) {
  return api.post(`/admin/inmates/${id}/temp-pin`);
}

export function getInmateResetRequests() {
  return api.get('/admin/inmate-reset-requests');
}


export function importInmatesCsv(file) {
  const formData = new FormData();
  formData.append('file', file);

  return api.post('/admin/inmates/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
